import React from 'react'
import { ListGroup } from 'react-bootstrap'
import SearchResultEvent from './SearchResultEvent'

const SearchResultListConfirmedBookings = ({ bookings, searchValue }) => {
  if(bookings.data.length === 0) {
    return null
  }

  const params = new URLSearchParams({
    "query[query]" : searchValue,
    "query[show_past]": "true",
    "query[show_future]": "true",
    "query[show_proposals]": "false",
    "query[show_confirmed_events]": "true",
    "query[show_sessions]": "true",
  })
  const moreResultsPath = `/events?${params.toString()}`

  return (
    <div className="mb-3">
      <h5>
        <a href={moreResultsPath} className="text-dark">
          Confirmed Bookings &raquo;
        </a>
      </h5>
      <ListGroup>
        {bookings.data.map(result => (
          <SearchResultEvent key={result.id} result={result} />
        ))}
      </ListGroup>
      <div className="text-end mt-2">
        <a className="text-muted" href={moreResultsPath}>Search all confirmed bookings &raquo;</a>
      </div>
    </div>
  )
}

export default SearchResultListConfirmedBookings
